export default "assets/images/logo-footer-mobile-9bb2e900.png";